<template>
    <SwLayout>
        <div class="dm-wizard-field" v-if="presentation && presentation.content">
            <TinyMce
                v-model="presentation.content.detailed_summary"
                toolbar="bold italic underline"
                :purifyContent="true"
                @change="validateAndSave()"
            />

            <WordCountWidget
                :word_count="wordCount"
                recommended_length="1500"
            />
        </div>
    </SwLayout>
</template>

<script>
import TinyMce from "@shared/TinyMce.vue";
import WordCountWidget from "@shared//WordCountWidget.vue";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState, mapActions } from "pinia";
import { getDistinctWordsCountInString } from "@/utilities/utilities.js";
import { validationMixin } from "@/mixins/validationMixin.js";

export default {
    mixins: [validationMixin],

    components: { TinyMce, WordCountWidget },

    data() {
        return {
            minLength: 1, // words. NB: I left it at 1 just so the 'Next' button is still disabled when first loading the page.
        };
    },

    computed: {
        ...mapWritableState(useSubmissionWizardStore, [
            "presentation",
            "bottom_navigation_rules",
        ]),

        isValid() {
            return this.wordCount >= this.minLength;
        },
        wordCount() {
            if (!this.presentation) return 0;
            if (!this.presentation.content) return 0;

            return this.getDistinctWordsCountInString(this.presentation.content.detailed_summary);
        },
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["savePresentation"]),

        getDistinctWordsCountInString,

        validateAndSave() {
            if (this.isValid)
                this.savePresentation();
        },
    },
};
</script>
